<template>
    <div 
        class="egg-wrapper" 
        @click="jump"
    >
        <img 
          :class="['egg-img', eggIsIdle ? 'idle' : 'active']"
          :src="eggImageUrl"
          ref="eggImg"
        >
        <img class="egg-shadow" src="../.././../public/assets/egg_shadow.png" ref="eggShadow">
    </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

import eggBeta from '@/assets/egg_beta.png';
import eggLeft from '@/assets/egg_left.png';
import eggRight from '@/assets/egg_right.png';
import { EggType } from '@/components/data/Data';


export default {
  name: 'Egg',
    props: {
      eggUrl: {
        type: String,
        default: 'egg_beta'
      },
      eggType: {
        type: String,
        default: EggType.BETA
      }
    },
    computed: {
      ...mapGetters([
        'eggIsIdle'
      ]),
      eggImageUrl() {
        if( this.eggType == EggType.LEFT ) {
          return eggLeft;
        } else if( this.eggType == EggType.RIGHT ) {
          return eggRight;
        }

        return eggBeta;
      }
    },

    mounted(){
      this.monitorJump();

    },
    methods: {
        ...mapMutations([
          'deactivateEgg'   
        ]),

        jump(){
            console.log('jump!');
            // let eggEl = document.querySelector("#egg-img");
            let eggEl = this.$refs.eggImg;
            eggEl.classList.add('bounce')                    

            eggEl.addEventListener('animationend', (e) => {
                console.log('animation end'); 
                if(e.animationName == 'eggBounce'){
                    eggEl.classList.remove('bounce');
                    eggEl.removeEventListener('animationend', () => {} );
                }
                
            });
        },

        monitorJump(){
          // let eggEl = document.querySelector("#egg-img");
          let eggEl = this.$refs.eggShadow;

          eggEl.addEventListener('animationend', (e) => {
            if (e.animationName == 'eggBounce' && this.eggIsIdle == false){
              this.deactivateEgg();
              console.log('egg fin')

            }

          });
        }
    }
}
</script>

<style lang="scss">
@import '../../styles/_mixins.scss';

  .egg-wrapper, .egg-spacer {

    padding-top: 56.25%;
    margin: 2em auto;
    position: relative;
    max-height: 40vh;
    transform: scale(0.85);

    &.left, &.right {
      position: absolute;
      top: 0;
      width: 100%;
      transform: scale(0.72);
    }

    &.left {
      left: -32%;

      .egg-img {
        &.active {
          @include bounce(1.55);
        }

        &.idle {
          @include eggIdle(1.75, 1.55);
        }
      }
    }

    &.right {
      right: -32%;

      .egg-img {
        &.active {
          @include bounce(1.525);
        }

        &.idle {
          @include eggIdle(1.75, 1.525);
        }
      }
    }

    @media screen and (min-width: 768px) {
        padding-top: 0;
        height: 30rem;
    }

    @media screen and (min-width: 600px) and (max-width: 768px) {
      min-height: 1.75rem;
      margin: 1.25em auto 2.15em auto;
    }

    @media only screen and (max-width: 600px) {
      min-height: 3.75rem;
      margin: 1em auto 3.25em auto;
    }

    @media only screen and (max-height: 600px) {
      padding-top: 45%;

      &.left {
        left: -27%;
      }

      &.right {
        right: -27%;
      }
    }
    
  }

  .egg-img {
    z-index: 2;
    height: 100%;
    width: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    max-height: 375px;
    display: block;

    @include crossBrowser(transform, translate(-50%, -50%));
    @include crossBrowser(transform-origin, left);

    &.active {
      @include bounce(1.5);
    }

    &.idle {
      @include eggIdle(1.75, 1.5);
    }    
  

  }

  .egg-shadow {
    z-index: 1;
    position: absolute;
    left: 50%;
    bottom: -0.75em;
    width: 10rem;

    @include crossBrowser(transform, translateX(-50%));
    
  }

</style>